
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom'

import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { Row, Col} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { parseQueryString } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import { getLogo } from '../../constants/multiDomains';


class ThankYouPage extends Component {
    constructor(props) {
        super(props);
        const countryCode = {
            'za': '27',
            'watch': '',
            'me': '',
            'ci': '225',
            'sn': '221',
            'cd': '243',
            'tn': '216',
            'cm': '237',
            'be': '32',
            'vn': '84'
        }

        this.state = {
            msisdn: countryCode[config.domain],
            domain: window.location.host,
            responseData:null
            
        };

        
    }
    componentWillMount(){
        this.verifyToken({
            token : parseQueryString(this.props.location.search)['token']
        });

    }

    verifyToken(input) {
        axios.get(vars.BASE_API_URL + `/verify_email/${input.token}`)
        .then((response) => {
            this.setState({
                responseData:response.data
            })
            // if (response.data.success) {
            //     alert('Verified Successfully');
            // }else {
            //     alert('Failed');
            // }
           
        })
        .catch((error) => {
            alert(error);
            //this.props.history.push("/restricted");
        })
    }

    render() {
        const {responseData}=this.state
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src={getLogo()} alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                           <Row className="login-page-content">
                                <h1>
                                    {responseData && responseData.success?
                                     <FormattedMessage id="verifiedEmailSucessMsg"
                                     defaultMessage="Thank You for email verification!"
                                 />:   <FormattedMessage id="verifiedEmailSucessMsg"
                                 defaultMessage="Invalid verification link!"
                             />
                                    }
                                   
                                </h1>
                                { responseData && responseData.success?
                                <Link to={`/?uid=${responseData.data.uid}`} className="reg-link">
                                    <FormattedMessage id="thankUBack"
                                        defaultMessage="Click here to go back."
                                    />
                                </Link>:null}
                            </Row>
                        </Col>
                    </Row>
                </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ThankYouPage);



// WEBPACK FOOTER //
// ./src/components/Register/ThankYouPage.js